import OffLine from '@/components/OffLine';
import OfflinePlaceholder from '@/components/OfflinePlaceholder';
import OnLine from '@/components/OnLine';
import StatisticsBar from '@/components/StatisticsBar';
import API from '@/config/api';
import apiRequest from '@/helpers/apiRequest';
import createArrayFromNumber from '@/utilities/createArrayFromNumber';
import React from 'react';

interface IDataItem {
  drawNumber: number;
  count: number;
  isPeak: boolean;
}

interface BarometerState {
  fetched: boolean;
  data: IDataItem[];
}

export default class Barometer extends React.Component<
  object,
  BarometerState
> {
  private numbers: number[] = createArrayFromNumber(49);

  constructor(props) {
    super(props);
    this.state = {
      fetched: false,
      data: this.numbers.map((num) => ({
        drawNumber: num,
        count: 0,
        isPeak: false,
      })),
    };
  }
  async fetchData() {
    try {
      const response = await apiRequest(API.stats.lottoBarometer);
      if (response) {
        this.setState({
          fetched: true,
          data: response.counts,
        });
      }
    } catch (error) {
      console.error('Barometer - fetchData failed', error);
    }
  }

  componentDidMount() {
    this.fetchData().then();
  }

  private get maxCount(): number {
    return this.state.fetched
      ? Math.max(...this.state.data.map((count) => count.count))
      : 1;
  }

  render(): JSX.Element {
    return (
      <div className="Barometer">
        <OffLine>
          <OfflinePlaceholder box={true} />
        </OffLine>
        <OnLine>
          <div className="Barometer__bars">
            {this.numbers.map((num) => {
              const data = this.state.data.find(
                (item) => item.drawNumber === num
              );
              return (
                data && (
                  <StatisticsBar
                    key={num}
                    label={data.drawNumber.toString()}
                    value={data.count}
                    maxValue={this.maxCount}
                    highlight={data.isPeak}
                    lottoBall={true}
                    isLoading={!this.state.fetched}
                  />
                )
              );
            })}
          </div>
        </OnLine>
      </div>
    );
  }
}
